import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { WaveDivider } from './WaveDivider';
export function HeroSection() {
  return <section className="relative min-h-screen bg-gradient-to-b from-[#0f1b2d] via-[#1a2e4a] to-[#3d7a8a] overflow-hidden" data-id="element-47">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-48">
        <div className="absolute top-20 left-10 w-64 h-64 bg-teal-400 rounded-full blur-3xl" data-id="element-49" />
        <div className="absolute bottom-40 right-10 w-96 h-96 bg-blue-400 rounded-full blur-3xl" data-id="element-50" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 pt-12 pb-8 md:pt-20 md:pb-16" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-52">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-53">
            Calma en el Turno:{' '}
            <span className="text-[#a8d8d8]" data-id="element-54">
              El Kit de Supervivencia para el Trabajador Hispano en USA.
            </span>
          </h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-55">
            Recupera el control de tu ansiedad en menos de 60 segundos con el{' '}
            <span className="text-amber-400 font-semibold" data-id="element-56">
              "Método de Discreción Total"
            </span>{' '}
            que nadie notará que estás usando.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mb-8 md:mb-12" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/bgUzUHWKYQHtnkhqabE1XC/portada_de_Calma_en_el_turno.png" alt="Calma en el Turno - Kit Digital disponible en todos tus dispositivos" className="max-w-full md:max-w-2xl mx-auto rounded-lg shadow-2xl shadow-black/30" data-id="element-58" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-59">
            <CTAButton data-id="element-60">¡QUIERO MI KIT DE CALMA AHORA!</CTAButton>
          </motion.div>
        </motion.div>
      </div>

      <WaveDivider fillColor="#0f1b2d" data-id="element-61" />
    </section>;
}